import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";

export const SimuliveIllustration = () => (
    <StyledIllustration
        fileName="Simulive.svg"
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9997 74.2122C39.9997 69.7939 43.5814 66.2122 47.9997 66.2122H137.109C141.527 66.2122 145.109 69.7939 145.109 74.2122V135.674C145.109 136.031 145.157 136.387 145.251 136.731L149.953 153.885C151.348 158.977 147.516 164 142.237 164H44.7886C39.841 164 36.0796 159.554 36.899 154.675L39.9444 136.541C39.9812 136.322 39.9997 136.101 39.9997 135.879V74.2122Z"
            fill="#006EFA"
        />
        <rect x="46" y="72" width="93.3333" height="60" rx="8" fill="white" className="Tone8" />
        <rect x="86.667" y="78.6665" width="46" height="46.6667" rx="8" fill="#FFD357" />
        <circle cx="56.0003" cy="88.6666" r="3.33333" fill="#FF3D23" />
        <path
            d="M75.8398 91.3333H79.4278V90.1546H77.1398V88.8199H79.2112V87.6759H77.1398V86.4453H79.4105V85.2666H75.8398V91.3333Z"
            fill="#333333"
            className="Tone1"
        />
        <path
            d="M72.6345 91.3333L74.9745 85.2666H73.6225L72.1232 89.3486L70.6238 85.2666H69.2285L71.5598 91.3333H72.6345Z"
            fill="#333333"
            className="Tone1"
        />
        <path d="M67.0547 85.2666V91.3333H68.3634V85.2666H67.0547Z" fill="#333333" className="Tone1" />
        <path d="M62.6416 85.2666V91.3333H66.0563V90.1113H63.9416V85.2666H62.6416Z" fill="#333333" className="Tone1" />
        <path d="M91.667 142.667H132.667" stroke="white" className="sTone8" strokeWidth="2" strokeLinecap="round" />
        <path d="M52.333 152H136" stroke="white" className="sTone8" strokeWidth="2" strokeLinecap="round" />
        <rect
            x="22"
            y="109.066"
            width="45.3333"
            height="18.6667"
            rx="4"
            transform="rotate(-15 22 109.066)"
            fill="#333333"
            className="Tone1"
        />
        <path
            d="M61.4902 109.144C61.2531 108.26 60.4037 107.723 59.4984 107.965C59.4024 107.991 59.2689 108.042 59.172 108.119L59.8184 106.307L58.6525 106.619L58.016 108.605C57.836 109.168 57.8 109.692 57.914 110.117C58.1786 111.105 59.1433 111.633 60.1652 111.359C61.1801 111.087 61.7548 110.132 61.4902 109.144ZM60.505 109.445C60.6207 109.877 60.3578 110.323 59.9121 110.442C59.4663 110.561 59.0297 110.304 58.9121 109.865C58.7963 109.433 59.0542 108.996 59.4999 108.876C59.9389 108.759 60.3874 109.006 60.505 109.445Z"
            fill="white"
            className="Tone8"
        />
        <path
            d="M53.5928 109.746C53.8299 110.631 54.6794 111.168 55.5847 110.925C55.6669 110.903 55.768 110.869 55.8617 110.807L55.352 112.553L56.4904 112.248L57.0487 110.217C57.2044 109.646 57.283 109.198 57.1691 108.773C56.9045 107.786 55.9397 107.258 54.9179 107.531C53.9029 107.803 53.3282 108.759 53.5928 109.746ZM54.5781 109.445C54.4623 109.013 54.7252 108.568 55.171 108.449C55.6168 108.329 56.0534 108.587 56.171 109.026C56.2868 109.458 56.0289 109.895 55.5831 110.014C55.1442 110.132 54.6957 109.884 54.5781 109.445Z"
            fill="white"
            className="Tone8"
        />
        <path
            d="M53.9315 112.934L53.689 112.028L51.9127 112.504L52.5468 111.496C52.9964 110.788 53.1339 110.259 52.9667 109.634C52.726 108.736 51.8103 108.364 50.8639 108.618C50.3976 108.743 49.974 109.054 49.6987 109.481L49.9872 110.558C50.2491 110.054 50.5945 109.697 51.0334 109.579C51.486 109.458 51.88 109.639 51.9811 110.016C52.0656 110.332 52.001 110.584 51.676 111.127L50.5427 113.07L50.7357 113.79L53.9315 112.934Z"
            fill="white"
            className="Tone8"
        />
        <path
            d="M49.7627 114.91L49.957 114.072C50.0198 113.813 50.0287 113.626 49.9791 113.441C49.8854 113.091 49.55 112.909 49.2002 113.003C48.871 113.091 48.6647 113.419 48.7584 113.768C48.8337 114.049 49.1138 114.217 49.3813 114.145L49.3882 114.143L49.1661 115.07L49.7627 114.91Z"
            fill="white"
            className="Tone8"
        />
        <path
            d="M45.0923 115.008C45.5475 115.144 46.0126 115.151 46.479 115.026C47.5538 114.731 48.1858 113.907 47.9084 112.872C47.6621 111.953 46.7872 111.54 45.8408 111.794C45.6556 111.844 45.4846 111.919 45.3909 111.981L45.2153 111.16L47.0258 110.675L46.7906 109.797L44.1502 110.505L44.7426 113.264C45.0364 113.017 45.3741 112.823 45.7513 112.722C46.3 112.575 46.7689 112.707 46.8883 113.152C47.0133 113.619 46.668 113.976 46.1673 114.11C45.7558 114.22 45.3039 114.18 44.8148 113.973L45.0923 115.008Z"
            fill="white"
            className="Tone8"
        />
        <path
            d="M44.3222 115.509L43.0597 110.797L42.2573 111.012L41.3101 111.729L41.5766 112.723L42.3388 112.166L43.3072 115.781L44.3222 115.509Z"
            fill="white"
            className="Tone8"
        />
        <circle
            cx="34.8256"
            cy="113.344"
            r="2.05111"
            transform="rotate(-15 34.8256 113.344)"
            fill="white"
            className="Tone8"
        />
        <path
            d="M32.6964 119.269C32.2503 117.604 33.2383 115.893 34.9032 115.446L35.8084 115.204C37.4733 114.758 39.1846 115.746 39.6307 117.411C39.6977 117.661 39.5493 117.918 39.2993 117.985L33.2703 119.6C33.0203 119.667 32.7634 119.519 32.6964 119.269Z"
            fill="white"
            className="Tone8"
        />
        <circle cx="116.898" cy="24.2314" r="11.3361" transform="rotate(2.13953 116.898 24.2314)" fill="#006EFA" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.032 20.0489C113.944 19.5604 112.734 20.429 112.849 21.6161L113.428 27.6098C113.542 28.7888 114.88 29.412 115.856 28.7406L120.898 25.2706C121.897 24.5836 121.759 23.0691 120.654 22.5727L115.032 20.0489Z"
            fill="white"
        />
        <rect
            x="106.933"
            y="55.9346"
            width="71.1662"
            height="46.3251"
            rx="8.05655"
            transform="rotate(8.64414 106.933 55.9346)"
            fill="#333333"
            className="Tone1"
        />
        <path
            d="M105.348 68.5963L107.339 68.8991C108.439 69.0662 109.466 68.3103 109.633 67.2105L109.936 65.2193C110.103 64.1195 111.13 63.3635 112.23 63.5307L169.644 72.2591C170.744 72.4263 171.5 73.4533 171.333 74.5531L170.98 76.8762C170.812 77.976 171.568 79.003 172.668 79.1702L174.991 79.5234"
            stroke="white"
            className="sTone8"
            strokeWidth="2"
            strokeLinecap="square"
        />
        <g clipPath="url(#clip0_88477_1538)">
            <rect
                x="110.527"
                y="68.0256"
                width="60.4241"
                height="27.5265"
                rx="13.7633"
                transform="rotate(8.64414 110.527 68.0256)"
                fill="#FF3D23"
            />
        </g>
        <circle
            cx="155.636"
            cy="88.465"
            r="8.05655"
            transform="rotate(8.64414 155.636 88.465)"
            fill="#333333"
            className="Tone1"
        />
        <circle
            cx="121.121"
            cy="83.2179"
            r="8.05655"
            transform="rotate(8.64414 121.121 83.2179)"
            fill="#333333"
            className="Tone1"
        />
        <circle
            cx="155.636"
            cy="88.4649"
            r="3.02827"
            transform="rotate(8.64414 155.636 88.4649)"
            stroke="white"
            className="sTone8"
            strokeWidth="2"
        />
        <circle
            cx="121.12"
            cy="83.2178"
            r="3.02827"
            transform="rotate(8.64414 121.12 83.2178)"
            stroke="white"
            className="sTone8"
            strokeWidth="2"
        />
        <rect
            x="123.803"
            y="70.0437"
            width="34.2403"
            height="27.5265"
            transform="rotate(8.64414 123.803 70.0437)"
            fill="#333333"
            className="Tone1"
        />
        <rect
            x="125.953"
            y="73.7661"
            width="28.8693"
            height="20.1414"
            rx="4.02827"
            transform="rotate(8.64414 125.953 73.7661)"
            fill="white"
            className="Tone8"
        />
        <rect
            x="128.052"
            y="76.1814"
            width="23.9943"
            height="15.9962"
            rx="4.02827"
            transform="rotate(8.64414 128.052 76.1814)"
            fill="#FF9DFF"
        />
        <path
            d="M119.871 58.254C120.236 53.8739 124.581 48.9971 128.633 47.5765C132.351 46.2736 138.869 45.8066 140.582 50.4718C141.487 52.9338 137.309 56.55 135.389 54.3476C134.163 52.9412 134.298 49.6668 134.914 48.0514C136.205 44.6642 140.253 42.7136 143.646 42.3833C147.775 41.9814 158.542 44.96 155.105 51.1459C153.49 54.0521 159.153 54.0739 160.911 54.3935C165.457 55.2201 169.659 55.8775 173.917 57.7025"
            stroke="#333333"
            className="sTone1"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <rect
            width="30.5362"
            height="23.0462"
            rx="11.5231"
            transform="matrix(-0.999967 0.00813106 0.00813102 0.999967 98.3545 30.9597)"
            fill="#FF9DFF"
        />
        <path
            d="M90.2932 58.7492L81.6621 51.2019L91.3874 51.1228L91.4451 58.2206C91.45 58.82 90.7444 59.1438 90.2932 58.7492Z"
            fill="#FF9DFF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.882 40.668C82.882 40.668 81.3112 38.3212 79.359 38.7442C77.4068 39.1672 76.397 41.6827 77.7298 43.7182C78.9364 45.5608 82.2624 47.736 83.1496 48.0559C83.2425 48.0894 83.3611 48.0885 83.4864 48.0476C86.0754 47.203 87.6797 45.2866 88.6507 43.6294C88.6507 43.6294 90.1797 40.5278 87.6143 39.0339C85.0489 37.54 82.882 40.668 82.882 40.668Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_88477_1538">
                <rect
                    width="61.7669"
                    height="20.1414"
                    fill="white"
                    className="Tone8"
                    transform="translate(109.359 71.2434) rotate(8.64414)"
                />
            </clipPath>
        </defs>
    </StyledIllustration>
);
